export const GSP = 1;
export const GSPS = 2;
export const NVT = 1;
export const PICS = 2;
export const NVP = 3;
export const CONFIG = 4;